// client/src/api/productos.js
import api from "./config.js";

// Obtener todos los productos
export const getProductos = async () => {
    const { data } = await api.get("/productos");
    return Array.isArray(data) ? data : data.productos || [];
};

// Obtener un producto por ID
export const getProducto = async (id) => {
    const { data } = await api.get(`/productos/${id}`);
    return data;
};

// Crear producto (soporte para archivos)
export const createProducto = async (producto) => {
    const formData = new FormData();
    Object.keys(producto).forEach((key) => {
        if (producto[key] !== null && producto[key] !== undefined) {
        formData.append(key, producto[key]);
        }
    });

    const { data } = await api.post("/productos", formData, {
        headers: { "Content-Type": "multipart/form-data" },
    });
    return data;
};

// Actualizar producto (soporte para archivos)
export const updateProducto = async (id, producto) => {
    const formData = new FormData();
    Object.keys(producto).forEach((key) => {
        if (producto[key] !== null && producto[key] !== undefined) {
        formData.append(key, producto[key]);
        }
    });

    const { data } = await api.put(`/productos/${id}`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
    });
    return data;
};

// Eliminar producto
export const deleteProducto = async (id) => {
    const { data } = await api.delete(`/productos/${id}`);
    return data;
};
